<header vid="7">
  <div class="logo" vid="8">
    <span vid="9">{{ game.active }} to play</span>
    <span vid="10">Playing as {{ game.player }}</span>
  </div>
  <mat-form-field>
    <mat-label>Time control</mat-label>
    <input matInput type="number" min="1" max="90" [disabled]="game.status !== 'PENDING'" [(ngModel)]="game.timer" (input)="onInputChange()">
  </mat-form-field>
  <button mat-raised-button color="primary" vid="11" (click)="start()"
    [disabled]="game.opponent !== 'white' || game.status !== 'PENDING'">Start</button>
  <button mat-raised-button color="primary" (click)="reverse()">Flip</button>
</header>

<main vid="12">
  <section class="board-container" vid="13" #container>
    <div class="board" vid="23">
      <ngx-chess-board #board [size]="settings.size" (moveChange)="onMoveChange($event)"></ngx-chess-board>
    </div>
  </section>

  <section class="side-panel" vid="97">
    <div class="clock-section" vid="98">
      <div class="timer-card" vid="99">
        <div class="timer-label" vid="100">White / Alireza F.</div>
        <div class="timer-value" vid="101">{{ (whiteTimer$ | async) | timer }}</div>
      </div>
      <div class="timer-card active" vid="102">
        <div class="timer-label" vid="103">Black / Magnus C.</div>
        <div class="timer-value" vid="104">{{ (blackTimer$ | async) | timer }}</div>
      </div>
    </div>

    <div class="action-card" vid="105">
      <h3 vid="106">Theoretical Advantage:<br vid="107">Modern Defense</h3>
      <div class="timer-label" style="color: black; margin-top: 12px;" vid="108">Stockfish {{ game.engine }} ({{
        game.score }})</div>
      <div class="eval-bar" vid="109">
        <div class="eval-fill" vid="110" [style.width.%]="game.eval"></div>
      </div>
    </div>

    <div class="move-history" vid="111">
      <div class="panel-header" vid="112">
        <span vid="113">Move Log</span>
        <span style="opacity: 0.5" vid="114">...</span>
      </div>
      <div class="move-list" vid="115" *ngFor="let move of moves">
        <div class="move-row" vid="116">
          <span class="move-num" vid="117">{{ move.number }}.</span>
          <span class="move-val" vid="118">{{ move?.white }}</span>
          <span class="move-val" vid="119">{{ move?.black }}</span>
        </div>
      </div>
    </div>

    <div class="controls" vid="148">
      <div class="btn-icon" vid="149" (click)="undo()">
        <svg viewBox="0 0 24 24" vid="150">
          <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" vid="151"></path>
        </svg>
      </div>
      <div class="btn-icon" style="background: var(--color-orange);" vid="152">
        <svg viewBox="0 0 24 24" style="fill: black;" vid="153">
          <path d="M8 5v14l11-7z" vid="154"></path>
        </svg>
      </div>
      <div class="btn-icon" vid="155">
        <svg viewBox="0 0 24 24" vid="156">
          <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" vid="157"></path>
        </svg>
      </div>

      <div class="btn-icon" style="margin-left: auto; border-radius: 8px; width: auto; padding: 0 16px;" vid="158"
        (click)="resign()">
        <span style="color: white; font-weight: 800; font-size: 12px; text-transform: uppercase;"
          vid="159">Resign</span>
      </div>
    </div>
  </section>
</main>